<template>
    <nav>
        <router-link tag="img" class="logo" :src="config.NAVBAR_LOGO" :to="welcome"/>
        <div class="profile">
            <router-link tag="img" class="picture" :src="user.picture" :to="{ name: 'profile' }"/>
            <Dropdown>
                <IconDropdown slot="trigger" :color="config.COLOR_PRIMARY"/>
                <div class="menu">
                    <ul>
                        <li v-for="(route, n) in routes" :key="n">
                            <router-link :to="route.to">
                                <component :is="route.icon"/> {{ route.name }}
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{ name: 'profile' }">
                                <IconProfile/> {{ config.NAVBAR_PROFILE }}
                            </router-link>
                        </li>
                        <li>
                            <a to="#" @click="onLogout">
                                <IconLogout/> {{ config.NAVBAR_LOGOUT }}
                            </a>
                        </li>
                    </ul>
                </div>
            </Dropdown>
        </div>
    </nav>
</template>
<script>
import { SolutionConsumer, UserConsumer, CoreConsumer } from '../../mixins';

export default {
    name: 'Navbar',
    mixins: [SolutionConsumer, UserConsumer, CoreConsumer],
    methods: {
        onLogout () {
            this.logout();
        },
    },
};
</script>
<style scoped lang="scss">
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px;
    background-color: $white;
    box-shadow: 0 6px 6px 0 rgba($black, .05);
    // Fix for box-shadow over next sibling that has a background image
    position: relative;
    z-index: 2;
    user-select: none;

    > .logo {
        max-height: 40px;
        margin-left: 20px;
        cursor: pointer;
    }

    > .profile {
        display: flex;
        align-items: center;

        > .picture {
            @include profile-picture();
            @include square(50px);
            cursor: pointer;
        }

        .menu {
            padding: 8px 0;
            border-radius: 6px;
            box-shadow: 20px 20px 30px 0 rgba($black, .1);
            background-color: $white;

            > ul {
                list-style-type: none;
                padding: 0;
                margin: 0;

                > li {
                    color: $grey-darkest;

                    > a {
                        display: flex;
                        align-items: center;
                        padding: 4px 8px;
                        text-transform: uppercase;
                        font-size: 12px;
                        font-weight: bold;
                        text-decoration: none;
                        letter-spacing: 1px;
                        cursor: pointer;

                        > svg {
                            @include square(32px);
                            margin-right: 8px;
                            fill: $grey-darkest;
                        }
                    }

                    &:hover {
                        background-color: $grey-darkest;
                        color: $white;

                        svg {
                            fill: $white;
                        }
                    }
                }
            }
        }

        svg {
            @include square(40px);
            // display: block;
            // margin: auto;
        }
    }
}
</style>
